/**
 * @param {import("../../../../../utils/router/Router").default} router
 */
export default function (router) {
  router.group(
    {
      path: "/alfred",
    },
    (router) => {
      router.group(
        {
          path: "/users",
        },
        (router) => {
          router.group(
            {
              path: "/two-factor-authentication",
            },
            (router) => {
              router.push({
                id: "@api/user.twoFactorAuthentication@status",
                path: "",
              });
              router.group(
                {
                  path: "/challenge",
                },
                (router) => {
                  router.group(
                    {
                      path: "/:challengeId",
                    },
                    (router) => {
                      router.group(
                        {
                          path: "/action",
                        },
                        (router) => {
                          router.push({
                            id: "@api/user.twoFactorAuthentication.challenge@notify",
                            path: "/notify",
                          });
                          router.push({
                            id: "@api/user.twoFactorAuthentication.challenge@complete",
                            path: "/complete",
                          });
                        },
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}
